import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import CookieBanner from './components/layout/CookieBanner';
import Home from './pages/Home';
import Presentation from './pages/Presentation';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Reviews from './pages/Reviews';
import Login from './pages/Login';
import Register from './pages/Register';
import BookingConfirmation from './pages/BookingConfirmation';
import MemberDashboard from './pages/MemberDashboard';
import MemberBookings from './pages/MemberBookings';
import MemberProfile from './pages/MemberProfile';
import AdminDashboard from './pages/AdminDashboard';
import AdminBookings from './pages/AdminBookings';
import AdminUsers from './pages/AdminUsers';
import AdminReviews from './pages/AdminReviews';
import AdminVehicles from './pages/AdminVehicles';
import AdminAnalytics from './pages/AdminAnalytics';
import MemberReview from './pages/MemberReview';
import LegalMentions from './pages/LegalMentions';
import Privacy from './pages/Privacy';
import CGV from './pages/CGV';
import './App.css';

function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    // Tracker chaque changement de page
    analytics.trackPageView(location.pathname);
  }, [location]);

  return null;
}

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <PageLoader />;
  if (!user) return <Navigate to="/connexion" replace />;
  return children;
}

function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <PageLoader />;
  if (!user) return <Navigate to="/connexion" replace />;
  if (user.role !== 'ADMIN') return <Navigate to="/" replace />;
  return children;
}

function PageLoader() {
  return (
    <div className="fixed inset-0 bg-desti-black flex items-center justify-center z-50">
      <div className="flex flex-col items-center gap-4">
        <div className="w-10 h-10 border-2 border-desti-gold/30 border-t-desti-gold rounded-full animate-spin" />
        <span className="text-desti-text text-sm tracking-widest uppercase">Chargement</span>
      </div>
    </div>
  );
}

function AppContent() {
  return (
    <div className="min-h-screen bg-desti-black flex flex-col">
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/presentation" element={<Presentation />} />
          <Route path="/mentions-legales" element={<LegalMentions />} />
          <Route path="/confidentialite" element={<Privacy />} />
          <Route path="/cgv" element={<CGV />} /> 
          <Route path="/service-vtc" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/avis" element={<Reviews />} />
          <Route path="/connexion" element={<Login />} />
          <Route path="/inscription" element={<Register />} />
          <Route path="/booking/confirmation" element={<BookingConfirmation />} />
          <Route path="/espace-membre/dashboard" element={<ProtectedRoute><MemberDashboard /></ProtectedRoute>} />
          <Route path="/espace-membre/reservations" element={<ProtectedRoute><MemberBookings /></ProtectedRoute>} />
          <Route path="/espace-membre/profil" element={<ProtectedRoute><MemberProfile /></ProtectedRoute>} />
          <Route path="/admin/dashboard" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
          <Route path="/admin/reservations" element={<AdminRoute><AdminBookings /></AdminRoute>} />
          <Route path="/admin/utilisateurs" element={<AdminRoute><AdminUsers /></AdminRoute>} />
          <Route path="/admin/analytics" element={<AdminRoute><AdminAnalytics /></AdminRoute>} />
          <Route path="/espace-membre/avis" element={<MemberReview />} />
          <Route path="/admin/avis" element={<AdminRoute><AdminReviews /></AdminRoute>} />
          <Route path="/admin/vehicules" element={<AdminRoute><AdminVehicles /></AdminRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
